import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const tk = localStorage.getItem('stilo_token');
  if (tk) cfg.headers.Authorization = `Bearer ${tk}`;
  return cfg;
});

export const authUrl = (path) =>
  `${API}${path}?auth=${encodeURIComponent(localStorage.getItem('stilo_token') || '')}`;

export const fmtPrice = (amount, currency = 'eur') => {
  try {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency.toUpperCase() }).format(amount);
  } catch { return `${amount} €`; }
};
